

import "../dashboard.css";
import {Doughnut, Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    Title,
    ArcElement,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';




ChartJS.register(
    CategoryScale,
    LinearScale,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    ChartDataLabels
);


export default function FarmByProjects({ data }) {

    return (        
       data ?
       <div>
        <h6>Farms by Projects Number</h6>
            <Doughnut
                data={{
                    labels: Object.keys(data),
                    datasets: [ 
                        {
                            label: 'Farms by Projects Number',
                            data: Object.values(data).map(farms => farms.length),
                            backgroundColor: [
                                'rgba(153, 248, 64, 0.6)',
                                'rgba(7, 150, 245, 0.6)',  
                                'rgba(243, 178, 14, 0.6)',
                                'rgba(3, 204, 120, 0.6)',
                                'rgba(84, 17, 218, 0.6)',
                                'rgba(255, 159, 64, 0.6)',
                            ],
                        },
                    ],
                }}
                options={{
                    responsive: true,
                    plugins: {
                        legend: {
                            position: 'bottom',
                        },
                        
                        datalabels: {
                            display: true, // Enable data labels    
                            color: 'black', // Color of the labels
                            anchor: 'end', // Position of the label relative to the bar (e.g., 'end', 'center', 'start')
                            align: 'end', // Alignment of the label text
                            formatter: (value, context) => {
                                // Optional: Customize the displayed value
                                return Object.values(data)[context.dataIndex].length;
                            }
                        },

                    }
                }}
                className="doughnutchart"
            />
            </div>
            : <p>Loading...</p>
    );
}